import { useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { obtenerInfoRefugio } from "../api/api-refugio";


const PetModal = ({ mascota, onClose }) => {
    // const [mascota, setMascota] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [imageUrls, setImageUrls] = useState([]);
    const [infoRefugio, setInfoRefugio] = useState(null);

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    useEffect(() => {
        fetchMascota();
    }, [mascota]);

    const fetchMascota = async () => {
        try {
            setLoading(true);
            // console.log('fetchMascota', mascota);
            const info = await obtenerInfoRefugio({ idMascota: mascota.id });
            // console.log('info', info);
            setInfoRefugio(info.body);
            let parsedImages = [];

            // Parse imagenes safely
            try {
                parsedImages = JSON.parse(mascota.imagenes);
            } catch (e) {
                console.error("Invalid image format", e);
            }

            setImageUrls(Array.isArray(parsedImages) && parsedImages.length > 0 ? parsedImages : []);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const closeModal = () => {
        setInfoRefugio(null);
        onClose();
    }

    const stopPropagation = (e) => e.stopPropagation();


    if (loading) {
        return (
            <div
                id="modalBackground"
                className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
                onClick={closeModal} // Click outside the modal closes it
            >
                <div
                    className="bg-white p-6 rounded-lg shadow-lg relative max-w-lg w-full"
                    onClick={stopPropagation} // Prevents clicks inside from closing the modal
                >
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white p-6 rounded shadow-lg">Loading...</div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div
                id="modalBackground"
                className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
                onClick={closeModal} // Click outside the modal closes it
            >
                <div
                    className="bg-white p-6 rounded-lg shadow-lg relative max-w-lg w-full"
                    onClick={stopPropagation} // Prevents clicks inside from closing the modal
                >
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
                        <div className="text-red-500">{error}</div>
                    </div>
                </div>
            </div>
        );
    };

    if (!mascota) return null;

    return (
        <div
            id="modalBackground"
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
            onClick={closeModal} // Click outside the modal closes it
        >
            <div
                className="bg-white p-6 rounded-lg shadow-lg relative max-w-lg w-full"
                onClick={stopPropagation} // Prevents clicks inside from closing the modal
            >
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg relative max-w-lg w-full">

                        {/* Close Button */}
                        {/* <button
                            className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full shadow-md hover:bg-red-700 transition"
                            onClick={() => { closeModal(); }}
                        >
                            ✕
                        </button> */}

                        <h2 className="text-2xl font-bold text-gray-800">Nombre: {mascota.nombre}</h2>
                        <p className="text-gray-600">Raza: {mascota.raza}</p>
                        <p className="text-gray-600">Color: {mascota.color}</p>

                        {/* Display Image or Carousel */}
                        <div className="mt-4 w-full h-64 flex justify-center items-center bg-gray-100 rounded">
                            {imageUrls.length > 1 ? (
                                <Slider {...sliderSettings} className="w-full h-full">
                                    {imageUrls.map((image, index) => (
                                        <div key={index} className="w-full h-64">
                                            <img
                                                src={image}
                                                alt={`Mascota ${index + 1}`}
                                                className="w-full h-full object-cover rounded"
                                            />
                                        </div>
                                    ))}
                                </Slider>
                            ) : imageUrls.length === 1 ? (
                                <img
                                    src={imageUrls[0]}
                                    alt={mascota.nombre}
                                    className="w-full h-full object-cover rounded"
                                />
                            ) : (
                                <svg
                                    className="w-16 h-16 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 7h18M3 12h18m-9 5h9"
                                    />
                                </svg>
                            )}
                        </div>

                        {infoRefugio !== null &&
                            <>
                                <br />
                                <h2 className="text-xl font-bold text-gray-800">Nombre Refugio: {infoRefugio.nombreRefugio}</h2>
                                <p className="text-gray-600">Direccion: {infoRefugio.direccion}</p>
                                <p className="text-gray-600">Numero Referencia: {infoRefugio.numeroReferencia}</p>
                                <p className="text-gray-600">Departamento: {infoRefugio.departamento}</p>
                            </>
                        }

                        <div className="mt-4 flex justify-end">
                            <button
                                className="bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-900 transition"
                                onClick={() => { closeModal(); }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PetModal;
